import React from "react";
import { Paper } from "@mui/material";

const AuthCard = ({ children }) => (
  <Paper
    sx={{
      p: 4,
      maxWidth: 420,
      width: "90%",
      borderRadius: 2,
      background: "rgba(25,33,54,0.7)",
      border: "1px solid rgba(255,255,255,0.1)",
      boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
      backdropFilter: "blur(12px)",
    }}
  >
    {children}
  </Paper>
);

export default AuthCard;
